export default __webpack_public_path__ + "static/media/aboutUS5.ef13e734.PNG";